import { fHumanReadableNumber } from '@aibees/shared/utils';
import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import * as SX from './sx';
import type { TreeItemMetadataCountProps } from './types';

function TreeItemMetadataCountComponent({
  item,
  metadataEnabled,
  metadataApiLoading,
}: TreeItemMetadataCountProps) {
  if (item.metadata?.comingSoon || !metadataEnabled) return null;
  if (metadataApiLoading) {
    return (
      <Box display="flex" justifyContent="center" alignContent="center">
        <CircularProgress sx={SX.metadataCountProgress} size={12} />
      </Box>
    );
  }
  return (
    <Typography variant="body5" color="grey.500">
      {fHumanReadableNumber(item.metadataCount ? item.metadataCount : 0)}
    </Typography>
  );
}

TreeItemMetadataCountComponent.displayName = 'TreeItemMetadataCount';

export const TreeItemMetadataCount = React.memo(TreeItemMetadataCountComponent);
